export default __webpack_public_path__ + "static/media/Torpedo-2Open.9f61f97d.jpg";